import React from 'react';
import PropTypes from 'prop-types';
const filter = require('lodash/filter');
import { Modal, Button, Form } from 'react-bootstrap';

const Globals = require('../../../../app/globals');
const KeyboardUtil = require('../../util/keyboard');
import ErrorBox from '../common/ErrorBox';
import DistributionRestrictionWarningBox from '../common/DistributionRestrictionWarningBox';
const ChannelStore = require('../../stores/channel_store_reflux');
import ChannelFolderTree from '../common/Tree/ChannelFolderTree';

const propTypes = {
    project: PropTypes.object.isRequired,
    submitHandler: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
    show: PropTypes.bool,
    error: PropTypes.object,
    disabled: PropTypes.bool,
    distributionRestrictedActivities: PropTypes.array,
};

const defaultProps = {
    error: null,
    disabled: false,
    distributionRestrictedActivities: [],
};

class TransferProjectModal extends React.Component {
    constructor(props) {
        super(props)
        const channelStoreState = ChannelStore.getState();
        this.getTargetChannels = this.getTargetChannels.bind(this);
        this.state = {
            channelStoreState: channelStoreState,
            targetChannels: this.getTargetChannels(channelStoreState),
            selectedChannelId: null,
            selectedFolderId: null,
        };
        this.submitHandler = this.submitHandler.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.onSelectChannel = this.onSelectChannel.bind(this);
        this.onSelectFolder = this.onSelectFolder.bind(this);
        this.onDistributionWarningCheck = this.onDistributionWarningCheck.bind(this);
        this.unsubscribes = [ChannelStore.listen(this.onChannelStoreChange.bind(this))];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    getTargetChannels(channelStoreState) {
        if (channelStoreState.channelsAndOrgs) {
            return filter(channelStoreState.channelsAndOrgs, (c) => c.id === this.props.project.channelId);
        }
        return [];
    }

    onChannelStoreChange(channelStoreState) {
        let newState = {
            channelStoreState: channelStoreState,
            targetChannels: this.getTargetChannels(channelStoreState),
        };

        this.setState(newState);
    }

    submitHandler() {
        if (this.state.selectedFolderId) {
            this.props.submitHandler(this.state.selectedFolderId);
        }
        else if (this.state.selectedChannelId) {
            this.props.submitHandler(null);   
        }
        else {
            console.error(`TransferProjectModal.submitHandler() - Unrecognized selection`);
        }
    }

    handleKeyDown(e) {
        e.stopPropagation();
        if (KeyboardUtil.isEnterKey(e.keyCode)) {
            this.submitHandler();
        }
    }

    onSelectChannel(channelId) {
        this.setState({ selectedChannelId: channelId, selectedFolderId: null });
    }

    onSelectFolder(folderId) {
        this.setState({ selectedFolderId: folderId, selectedChannelId: null });
    }

    onDistributionWarningCheck(val) {
        this.setState({ warningAccepted: val });
    }

    render() {
        let folders;
        let foldersFlat;
        if (this.props.project.content_type === Globals.content_type.ACTIVITY) {
            folders = this.state.channelStoreState.folders;
            foldersFlat = this.state.channelStoreState.foldersFlat;
        }
        else if (this.props.project.content_type === Globals.content_type.COURSE) {
            folders = this.state.channelStoreState.shortCourseFolders;
            foldersFlat = this.state.channelStoreState.shortCourseFoldersFlat;
        }

        return (
            <Modal
                className='single-input-modal'
                show={this.props.show}
                enforceFocus={false}
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>Move Project</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorBox error={this.props.error} />
                    {(!!this.props.distributionRestrictedActivities && this.props.distributionRestrictedActivities.length > 0) &&
                        <DistributionRestrictionWarningBox
                            className="font-size-md"
                            distributionRestrictedActivities={this.props.distributionRestrictedActivities}
                            onChangeAcceptance={this.onDistributionWarningCheck}
                        />
                    }
                    <Form>
                        <Form.Group>
                            <Form.Label htmlFor="copy-project-channel-tree">Select destination</Form.Label> 
                            <ChannelFolderTree
                                id="copy-project-channel-tree"
                                className="margin-top-md"
                                channels={this.state.targetChannels}
                                folders={folders}
                                foldersFlat={foldersFlat}
                                selectedChannelId={this.state.selectedChannelId}
                                selectedFolderId={this.state.selectedFolderId}
                                selectedFolder={this.state.selectedFolder}
                                onSelectChannel={this.onSelectChannel}
                                onSelectFolder={this.onSelectFolder}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        disabled={
                            this.props.disabled
                            || (!this.state.selectedChannelId && !this.state.selectedFolderId)
                            || (!!this.props.distributionRestrictedActivities && this.props.distributionRestrictedActivities.length > 0 && !this.state.warningAccepted)
                        }
                        onClick={this.submitHandler}
                    >
                        move
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default TransferProjectModal;

TransferProjectModal.propTypes = propTypes;
TransferProjectModal.defaultProps = defaultProps;
